import { render, staticRenderFns } from "./businessCategory.vue?vue&type=template&id=f889a26e&scoped=true&"
import script from "./businessCategory.vue?vue&type=script&lang=js&"
export * from "./businessCategory.vue?vue&type=script&lang=js&"
import style0 from "./businessCategory.vue?vue&type=style&index=0&id=f889a26e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f889a26e",
  null
  
)

export default component.exports